import { useLocalStorage } from "usehooks-ts"

import { LOCAL_STORAGE_KEYS } from "~config/constants"
import type { EventOrganizerTypeForContext } from "~contexts/outfitter-provider"

export function usePersistedEventOrganizer(
    initialEventOrganizer?: EventOrganizerTypeForContext
) {
    const [eventOrganizer, setEventOrganizer] =
        useLocalStorage<EventOrganizerTypeForContext>(
            LOCAL_STORAGE_KEYS.MB_GLOBAL_EVENT_ORGANIZER,
            initialEventOrganizer
        )

    return { eventOrganizer, setEventOrganizer }
}
